import React from 'react';
import { FaUser, FaCrown, FaGift } from 'react-icons/fa';
import '../../styles/UserAccountCard.css';

/**
 * Props pour le composant UserAccountCard
 * @typedef {Object} UserAccountCardProps
 * @property {Object|null} twitchUser - L'utilisateur Twitch connecté (display_name, profile_image_url, login)
 * @property {Object|null} [user] - Utilisateur session (fallback: twitchDisplayName, profileImageUrl si twitchUser absent)
 * @property {boolean} [isPremium] - Indique si l'utilisateur a un abonnement premium
 * @property {boolean} [isTrial] - Indique si l'utilisateur est en période d'essai
 */

/**
 * Carte compacte affichant le compte utilisateur connecté dans la sidebar
 *
 * @component
 * @param {UserAccountCardProps} props - Les props du composant
 * @returns {JSX.Element|null} La carte utilisateur ou null si pas d'utilisateur
 */
function UserAccountCard({ twitchUser, user = null, isPremium = false, isTrial = false }) {
  const displayName =
    twitchUser?.display_name ||
    twitchUser?.login ||
    user?.twitchDisplayName ||
    user?.twitchLogin ||
    user?.username ||
    user?.name ||
    null;
  const avatarUrl =
    twitchUser?.profile_image_url ||
    twitchUser?.profileImageUrl ||
    user?.profileImageUrl ||
    null;

  if (!displayName) {
    return null;
  }

  const accountStatusLabel = isPremium ? 'Premium' : isTrial ? 'Essai' : 'Gratuit';
  const accountStatusVariant = isPremium ? 'premium' : isTrial ? 'trial' : 'free';

  return (
    <div className="user-account-card">
      <div className="user-account-card__avatar">
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={`Avatar de ${displayName}`}
            className="user-account-card__avatar-img"
            loading="lazy"
          />
        ) : (
          <div className="user-account-card__avatar-fallback">
            <FaUser aria-hidden />
          </div>
        )}
      </div>
      <div className="user-account-card__info">
        <span className="user-account-card__label">Compte connecté</span>
        <span className="user-account-card__name">{displayName}</span>
        <span
          className={`user-account-card__badge user-account-card__badge--${accountStatusVariant}`}
          title={accountStatusLabel}
        >
          {isPremium ? (
            <FaCrown className="user-account-card__badge-icon" aria-hidden />
          ) : isTrial ? (
            <FaGift className="user-account-card__badge-icon" aria-hidden />
          ) : null}
          <span>{accountStatusLabel}</span>
        </span>
      </div>
    </div>
  );
}

export default UserAccountCard;
